<template>
  <div :class="['prod-item', {'order-item': from === 'order'}, {'refund-item': from === 'refund'}]">
    <div class="img-box">
      <img :src="itemData.prodPic || itemData.pic || 'https://dsl-ds.oss-cn-shenzhen.aliyuncs.com/90CB5C2F50384FBE8B1A0753FB7DB1CA.png'" alt="">

      <!-- <div class="blur-box" v-if="itemData.isPrescriptionMedicine === 1">
        <div class="tips">处方药合规要求不展示包装</div>
      </div> -->
    </div>

    <div class="msg-box">
      <div class="prod-name">
        <!-- <span class="tag" v-if="itemData.isPrescriptionMedicine === 1">处方药</span> -->
        {{itemData.prodName || itemData.drugName}}
      </div>

      <template v-if="from !== 'refund'">
        <div class="prod-spec">{{itemData.isServiceGoods ? itemData.spec : itemData.skuName}}</div>

        <div class="prod-num" v-if="from !== 'order'">x {{itemData.prodCount || itemData.count}}</div>

        <div class="prod-price">¥<span>{{itemData.price}}</span></div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemData: {
      type: Object,
      value: null,
    },
    from: {
      type: String,
      value: '', // order-正常订单 refund-退款订单
    },
  },
};
</script>

<style lang="scss" scoped>
.prod-item {
  @include flex(stretch);

  padding: 16px;
}

.img-box {
  flex-shrink: 0;
  border-radius: 4px;
  margin-right: 8px;
  position: relative;
  overflow: hidden;
}

.img-box img,
.blur-box {
  display: block;
  width: 80px;
  height: 80px;
}

.blur-box {
  @include flex();

  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(4px);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  .tips {
    @include font(12px, 16px, $secondary-text-color, center);

    padding: 12rpx;
    position: relative;
    z-index: 1;
  }
}

.msg-box {
  width: calc(100% - 88px);
  position: relative;

  .prod-name {
    @include line-ellipsis();
    @include font(15px, 21px, $base-text-color);

    .tag {
      display: inline-block;
      background-color: #ffa433;
      border-radius: 4px;
      padding: 0 4px;
      margin-right: 6px;
      color: #fff;
      font-size: 12px;
      line-height: 16px;
    }
  }

  .prod-spec {
    opacity: 0;

    @include font(13px, 18px, $secondary-text-color);

    padding: 8px 0 10px;
  }

  .prod-num {
    @include font(12px, 17px, $info-text-color);
  }

  .prod-price {
    @include font(12px, 17px, $base-text-color);

    font-weight: $font-bold;
    position: absolute;
    right: 0;
    bottom: 0;

    span {
      font-size: 16px;
    }
  }
}

.order-item,
.refund-item {
  .prod-price span {
    font-size: 18px;
  }
}

.order-item {
  .prod-price {
    padding-top: 3px;
    position: static;
  }
}

.refund-item {
  .msg-box {
    width: calc(100% - 54px);
  }

  .img-box img,
  .blur-box {
    width: 54px;
    height: 54px;
  }

  .prod-name {
    @include multi-ellipsis();

    white-space: break-spaces;
  }
}
</style>
